<template>
  <div>
  <div class="loading-spinner-outer" v-if="loading">
    <div class="loading-spinner-inner">
      <div class="loading-spinner"></div>
    </div>
  </div>
    <div v-if="!loading">
        <div class="flex-xs justify-between p-3 pl-0-md pr-0-md pb-3">
            <div class="flex flex-col justify-around mb-3 mb-0-xs">
                <a class="btn-primary" href="/commercial/installation-of-the-month/entries">
                    View This Months Entries
                </a>
            </div>
            <div class="flex justify-end">
                <div class="flex flex-col justify-around pl-3 pr-3">
                    Select Month:
                </div>
                <div class="flex flex-col justify-around">
                    <select class="form-control" v-model="selected_month" style="width: 150px;">
                        <option v-for="(month, index) in months" :value="month">
                            {{ month.month }} {{ month.year }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div v-if="submissions.length > 0">
            <div class="installation-of-the-month-submissions">
                <div v-for="submission in submissions" class="installation-of-the-month-submission" :class="{ '_winner' : submission.winner }">
                    <div class="winner-bar" v-if="submission.winner">
                        <div><i class="fal fa-medal"></i></div>
                        <div>Winning Entry</div>
                    </div>
                    <div class="details">
                        <h1 class="title">{{ submission.title }}</h1>
                        <strong class="submitted-by">Submitted by: {{ submission.user.company.name }}</strong>
                        <p class="description" v-html="submission.description">
                        </p>
                        <div class="flex mt-3">
                            <a :href="'/commercial/installation-of-the-month/' + submission.id" class="btn-primary">
                                View Details
                            </a>
                            <div class="btn-primary" @click.stop="pickWinner(submission.id)" v-if="!submission.winner">
                                Choose Winner
                            </div>
                        </div>
                    </div>
                    <div class="installation-of-the-month-attachments">
                        <div v-for="(attachment, index) in submission.attachments" class="attachment">
                            <div @click="selected_submission = submission, selected_image_index = index" :style="attachmentThumbUrl(attachment)" class="image">
                                <span class="view-btn"><i class="fal fa-search"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="total_count > 5">
                <div class="pagination-bar wrapper mb-3 mt-3">
                    <div class="row">
                        <div class="col">
                            <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                                class="fa fa-caret-left"></i></a>
                            <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                            <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                               class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                        </div>
                        <div class="col align-right">
                            <div class="mt-1 mb-1">
                                {{ total_count }} entries
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="box" v-else>
          <div class="box-content">
          <strong>No entries found</strong>
          </div>
        </div>
        <div class="installation-of-the-month-attachments-modal-window" :class="{'open': selected_submission !== null}" @click="selected_submission = null, selected_image_index = 0" v-if="selected_submission !== null">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="selected_submission = null, selected_image_index = 0">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-content">
                    <div class="selected-image">
                        <img :src="`${$aws_bucket_url}${selected_submission.attachments[selected_image_index].file_url}`">
                        <a class="download-button" @click.prevent="downloadAttachment(selected_submission.attachments[selected_image_index].id)">
                            <i class="fal fa-download"></i>
                        </a>
                    </div>
                    <div class="installation-of-the-month-attachments">
                        <div v-for="(attachment,  index) in selected_submission.attachments" class="attachment">
                            <a @click.prevent="selected_image_index = index" :style="attachmentThumbUrl(attachment)" class="image">
                                <span class="view-btn"><i class="fal fa-search"></i></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
    data() {
        return {
          months: [],
            this_month: 0,
            last_month: 0,
            selected_month: 0,
            submissions: [],
            current_page: 1,
            total_count: 0,
            total_pages: 0,
            loading: true,
          selected_submission: null,
          selected_image_index: 0,
        };
    },
    async mounted() {
      await this.loadAvailableMonthsAndYears();
      await this.loadPastSubmissions();
    },
    methods: {
      async loadAvailableMonthsAndYears() {
        axios.post( '/commercial/installation-of-the-month/getAvailableMonthsAndYears').then((response) => {
          this.months = response.data;
          this.selected_month = this.months[this.months.length -1];
        });
      },
        async loadPastSubmissions() {
            this.loading = true;
            axios.post( '/commercial/installation-of-the-month/loadPastSubmissions', {
                page_number: this.current_page,
                selected_month: this.selected_month,
            }).then((response) => {
                this.submissions = response.data.data;
                this.total_count = response.data.total;
                this.total_pages = response.data.last_page;
                this.loading = false;
            });
        },
        prevPage() {
            this.current_page = this.current_page - 1;
            this.loadPastSubmissions();
        },
        nextPage() {
            this.current_page = this.current_page + 1;
            this.loadPastSubmissions();
        },
      attachmentUrl(attachment) {
        return {'backgroundImage' : `url('${this.$aws_bucket_url}${attachment.file_url}')`};
      },
      attachmentThumbUrl(attachment) {
        return {'backgroundImage' : `url('${this.$aws_bucket_url}${attachment.thumbnail_url}')`};
      },
      downloadAttachment(attachment_id) {
        axios.post( '/commercial/installation-of-the-month/download-attachment', {
          attachment_id: attachment_id,
        }).then((response) => {
          window.location.href = response.data;
        });
      },
        monthName(month) {
            return this.months[month];
        },
      pickWinner(submission_id) {

        Swal.fire({
          title: 'Are you sure?',
          text: "This entry will be marked as this month winner, they will be notified and their entry will be displayed on the dashboard.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, pick this entry'
        }).then((result) => {
          if (result.isConfirmed) {
            axios.post( '/commercial/installation-of-the-month/pickWinner', {
              submission_id: submission_id,
            }).then((response) => {
              this.loadPastSubmissions();

              Swal.fire(
                'Winner Picked',
                'This entry has been picked as the winner',
                'success'
              )

            });

          }
        });
      },
    },
    watch: {
        selected_month() {
            this.loadPastSubmissions();
        },
    }
}
</script>
